import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "../../../../firebase/firebase";
import { useEffect, useState } from "react";
import { SignupContext } from "../../../../context/SignupContext";
import * as Yup from "yup";
import Button from "../../../../components/Button";

const Step2 = () => {
  const navigate = useNavigate();
  const { formData } = useContext(SignupContext);
  useEffect(() => {
    return () => {};
  }, []);

  const goBack = () => {
    navigate(-1);
  };
  return (
    <section>
      <div className="container">
        <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
          {/* Left Container */}
          <div className="flex flex-col items-start justify-start">
            <h1 className="herotitle">Skarvo</h1>
            <p className="text-xl font-normal">Check your email to continue sign up.</p>
          </div>

          {/* Right Container */}
          <div className="flex flex-col gap-10">
            <div className="flex flex-col items-start formcard">
              <div className="flex flex-row items-start formheader">
                <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Sign Up</div>
              </div>
              <div className="flex justify-center w-full px-[30px] mb-[30px]">
                <div className=" bg-skseparatorgray w-full rounded-full h-[5px]">
                  <div className=" bg-skgreen h-[5px] rounded-full" style={{ width: "25%" }}></div>
                </div>
              </div>

              <div className="mb-5 px-[30px] flex flex-col space-y-[10px] w-full">
                <p className="block mb-2 text-base font-medium text-gray-900 dark:text-white">
                  Verify your email by tapping the link sent to <span className="font-bold ">{formData.email}</span> to continue your sign-up process.
                  <br />
                  <br />
                  For security, the link expires in 24 hours.
                </p>
              </div>
              <div className="thickseparator"></div>
              <div className="flex flex-col items-center justify-between w-full p-[30px] md:flex-row-reverse  gap-y-[30px]">
                <Link to="/" className="w-full text-base md:w-auto md:min-w-[200px] p-[10px] m-auto popup-button-action !h-fit">
                  Sign up with different email?
                </Link>
                {/* <button className="text-black bg-white popup-button-action" onClick={goBack}>
                  Sign up with different email?
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step2;
